/* globals window */

export const shutdownIntercom = () => {
  if (window && window.Intercom) {
    window.Intercom('shutdown')
  }
}
